import { BadgeDefinition } from '../../model/badge/badge-definition.model';
import { BadgeHistory } from '../../model/badge/badge-history.model';
import { CampaignServiceProvider } from '../../../ranking/services/campaign-service/campaign-service';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { DisplayServiceProvider } from '../../../core/services/display-service/display-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LevelDefinition } from '../../model/level/level-definition.model';
import { LevelHistory } from '../../model/level/level-history.model';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { ENVIRONMENT } from '../../../../../environments/environment';

// todo: refactor
@Injectable()
export class AchievementsServiceProvider {
  private readonly achievementsUrl: string = '../../../../assets/achievements.json';
  public levelsHistory: LevelHistory[] = [];
  public levelsDefinitions: LevelDefinition[] = [];
  public badgesDefinitions: BadgeDefinition[] = [];
  public badgesHistory: BadgeHistory[] = [];
  public badgeProgress = [];

  constructor(
    private campaignService: CampaignServiceProvider,
    private configService: ConfigServiceProvider,
    private displayService: DisplayServiceProvider,
    private http: HttpClient,
    private storageService: StorageServiceProvider,
  ) {}

  public getAchievedBadges() {
    let achievedBadges = [];
    for (let badgeDefinition of this.badgesDefinitions) {
      const achievedBadge = this.badgesHistory.find((entry) => entry.badgeId === badgeDefinition.id);
      achievedBadges.push(achievedBadge);
    }
    return achievedBadges;
  }

  public getAchievedLevels() {
    let userCampaigns = this.campaignService.getUserCampaigns();
    let currentLevels = [];

    if (userCampaigns && userCampaigns.length > 0 && this.levelsHistory && this.levelsHistory.length > 0) {
      for (let i = 0; i < userCampaigns.length; i++) {
        for (let j = 0; j < this.levelsHistory.length; j++) {
          if (this.levelsHistory[j].params.campaign && userCampaigns[i] === this.levelsHistory[j].params.campaign) {
            let level = this.getLevelById(this.levelsHistory[j].currentLevelId);

            if (level) {
              currentLevels.push(level);
            }
            break;
          }
        }
      }
    }

    return currentLevels;
  }

  public getNewBadges(currentBadges, savedBadges) {
    let newBadges = [];

    for (let i = 0; i < currentBadges.length; i++) {
      for (let j = 0; j < savedBadges.length; j++) {
        if (currentBadges[i].badgeId === savedBadges[j].badgeId) {
          if (currentBadges[i].badgeLevel > savedBadges[j].badgeLevel) {
            newBadges.push(currentBadges[i]);
          }
          break;
        } else if (j === savedBadges.length - 1) {
          newBadges.push(currentBadges[i]);
        }
      }
    }

    return newBadges;
  }

  public getNewLevels(currentLevels, savedLevels) {
    let newLevels = [];

    for (let i = 0; i < currentLevels.length; i++) {
      for (let j = 0; j < savedLevels.length; j++) {
        if (currentLevels[i].params.campaign === savedLevels[j].params.campaign) {
          if (currentLevels[i].level > savedLevels[j].level) {
            newLevels.push(currentLevels[i]);
          }
          break;
        } else if (j === savedLevels.length - 1) {
          newLevels.push(currentLevels[i]);
        }
      }
    }

    return newLevels;
  }

  public getLevelById(levelId) {
    for (let i = 0; i < this.levelsDefinitions.length; i++) {
      if (this.levelsDefinitions[i].id === levelId) {
        return this.levelsDefinitions[i];
      }
    }
  }

  public static sortByDate(a, b) {
    return Number(new Date(b.date)) - Number(new Date(a.date));
  }

  public load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.getSource())
        .toPromise()
        .then((response: any) => {
          let badgesDefs = response.badgeDefinitions;
          let badgesDefsMap = {};

          for (let i = 0; i < badgesDefs.length; i++) {
            badgesDefsMap[badgesDefs[i].id] = badgesDefs[i];
          }

          Promise.all([
            this.storageService.setObject('levelsDefinitions', response.levelDefinitions),
            this.storageService.setObject('badgesDefinitions', badgesDefsMap),
            this.storageService.setObject('levelsHistory', response.levelHistory),
            this.storageService.setObject('badgesHistory', response.badgeHistories),
            this.storageService.setObject('experiencePoints', response.experiencePoints),
            this.storageService.setObject('badgeProgress', response.badgeProgress || []),
          ])
            .then(() => {
              this.levelsHistory = response.levelHistory.sort(AchievementsServiceProvider.sortByDate);
              this.levelsDefinitions = response.levelDefinitions;
              this.badgesDefinitions = response.badgeDefinitions;
              this.badgesHistory = response.badgeHistories.sort(AchievementsServiceProvider.sortByDate);
              this.badgeProgress = response.badgeProgress;
              return this.findNewBadges();
            })
            .then(() => resolve())
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });
  }

  public loadNotDisplayed() {
    return new Promise<any>((resolve, reject) => {
      this.http
        .get(this.getSource() + "?to_display=true")
        .toPromise()
        .then((response: any) => {
            resolve({
              levelHistories: response.levelHistory,
              badgeHistories: response.badgeHistories,
              levelDefinitions: response.levelDefinitions,
              badgeDefinitions: response.badgeDefinitions,
            })
        }).catch((error) => reject(error));
    })
  }

  public updateLevelHistory(id: number, levelHistory: {to_display: boolean}) {
    this.http.patch(`${this.configService.getUrl('levelHistories')}/${id}`, levelHistory).subscribe(() => {}, e => console.log(e))
  }

  public updateBadgeHistory(userId: number, badgeId: number, badgeLevel: number, badgeHistory: {to_display: boolean}) {
    this.http.patch(`${this.configService.getUrl('badgeHistories')}/${userId},${badgeId},${badgeLevel}`, badgeHistory).subscribe(() => {}, e => console.log(e))
  }

  private getSource(): string {
    if (ENVIRONMENT.useLocalAchievements) return this.achievementsUrl;
    return this.configService.getUrl('achievements');
  }

  public getLevelsDef() {
    return this.storageService.getObject('levelsDefinitions');
  }

  public getBadgesDef() {
    return this.storageService.getObject('badgesDefinitions');
  }

  public getBadgesHistory() {
    return this.storageService.getObject('badgesHistory');
  }

  public getLevelsHistory() {
    return this.storageService.getObject('levelsHistory');
  }

  public getExpPoints() {
    return this.storageService.getObject('experiencePoints');
  }

  public getCurrentBadges() {
    return this.storageService.getObject('currentBadges');
  }

  public getProgressForBadge(id: string) {
    return this.storageService.getObject('badgeProgress').then((badges: Array<any>) => {
      for (let i = 0; i < badges.length; i++) {
        let badge = badges[i];
        if (id === '' + badge.badgeId) {
          return badge;
        }
      }
      return null;
    });
  }

  public setCurrentBadges(currentBadges) {
    return new Promise<void>((resolve, reject) => {
      this.storageService
        .setObject('currentBadges', currentBadges)
        .then(() => resolve())
        .catch((error) => reject(error));
    });
  }

  public getCurrentLevels() {
    return this.storageService.getObject('currentLevels');
  }

  public setCurrentLevels(currentLevels) {
    return new Promise<void>((resolve, reject) => {
      this.storageService
        .setObject('currentLevels', currentLevels)
        .then(() => resolve())
        .catch((error) => reject(error));
    });
  }

  public findNewLevels() {
    let achievedLevels = this.getAchievedLevels();
    return new Promise<void>((resolve, reject) => {
      this.getCurrentLevels()
        .then((response) => {
          if (response) {
            let newLevels = this.getNewLevels(achievedLevels, response);

            if (newLevels && newLevels.length > 0) {
              this.displayService.setNewLevels(newLevels);
            }
          }
        })
        .then(() =>
          this.setCurrentLevels(achievedLevels)
            .then(() => resolve())
            .catch((e) => reject(e)),
        );
    });
  }

  public findNewBadges() {
    let achievedBadges = this.getAchievedBadges();

    return new Promise<void>((resolve, reject) => {
      this.getCurrentBadges()
        .then((response) => {
          if (response) {
            let newBadges = this.getNewBadges(achievedBadges, response);

            if (newBadges.length > 0) {
              this.displayService.setNewBadges(newBadges);
            }
          }
        })
        .then(() =>
          this.setCurrentBadges(achievedBadges)
            .then(() => resolve())
            .catch((e) => reject(e)),
        )
        .catch(() => resolve());
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/achievement/services/achievements-service/achievements-service.ts